
<!-- <app-data-table [columns]="cols" [data]="systems" [title]="title"></app-data-table> -->


<ng-container>
    <app-data-table [columns]="cols" [data]="venderList" title="Vendors"  [isDeletable]="'/master/vendor-master' | hasPermission: 'Delete'"  [showAddButton]="'/master/vendor-master' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/vendor-master' | hasPermission: 'Edit'"  (deleteEventRow)="showDeletePopup($event)"  (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords"  [isView]="'/master/vendor-master' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)" 
       (onAdd)="addSystem()" (editEventRow)="onEdit($event)" [showAddButton] = "true" [url]="'/master/vendor/'"></app-data-table>
</ng-container>

<app-reusable-dialog
  [(visible)]="showDialog"
  [config]="dialogConfig"
  [initialData]="initialData"
  [viewMode]="viewMode"
  (onSubmit)="onDialogSubmit($event)"
  (onCancel)="onDialogCancel()"
  (onClose)="onDialogClose()">
</app-reusable-dialog>

<p-dialog header="Delete Vendor" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog mt-3">
     <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete vendor ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()" class="mt-2"> 
    </p-button>
  </div>
</p-dialog>